module.exports = __webpack_public_path__ + "img/img29.ea676bd4.jpg";